import {
    Box, PopoverArrow, PopoverBody, Text, VStack,
} from '@chakra-ui/react';

export function ComplianceSummaryPopoverContent() {
    return (
        <>
            <PopoverArrow />
            <PopoverBody fontSize="sm">
                <VStack gap={2} align="start">
                    <Box mt={2}>
                        <Text fontWeight="bold">Overdue</Text>
                        <Text color="muted.700">
                            A service will be marked as &quot;Overdue&quot; where the period
                            of time elapsed since the last service date exceeds the
                            required service frequency.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Approaching next service</Text>
                        <Text color="muted.700">
                            A service will be marked as &quot;Approaching next service&quot;
                            where the last service date indicates that the next service is due
                            within the next 30 days.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Missing service provider</Text>
                        <Text color="muted.700">
                            A property and service will be marked as
                            &quot;Missing service provider&quot; where Your Data does not
                            include a service provider in respect of one or more services.
                        </Text>
                    </Box>

                    <Box mt={2}>
                        <Text fontWeight="bold">Missing last service date</Text>
                        <Text color="muted.700">
                            A property will be marked as &quot;Missing last service date&quot; where
                            Your Data does not include a last service date for one or more services.
                        </Text>
                    </Box>
                </VStack>
            </PopoverBody>
        </>
    );
}
